import { defineComponent as _defineComponent } from 'vue'
import {ref} from 'vue';
import RelatedPurchaseList from './RelatedPurchaseList.vue';
import RelatedProcessing from './RelatedProcessing.vue';
import MyQuoteList from './MyQuoteList.vue';
import MyPurchase from './MyPurchase.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BusinessOpportunity',
  setup(__props, { expose }) {
  expose();

const active = ref('relatedPurchase');

const __returned__ = { active, ref, RelatedPurchaseList, RelatedProcessing, MyQuoteList, MyPurchase }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})